import psHttp, { RequestChannel, psHttp$ } from '@patsnap/common-ps-http';
import { currentClientUUID } from '@patsnap/uniform-setting';
import { coreBasicApiUrlPrefix, coreSearchApiUrlPrefix } from '../../config/constants';
import _ from 'lodash';
import qs from 'qs';
import { includeSemanticSorting } from 'library-@/utils/validateQueryLength';
const SEMANTIC_RESULT_SORT = 'sdesc';

// 方法名规范 getKeyWordsApi， 要以 Api 结尾

export function getQueryCountApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/patent/query/count`,
        method: 'POST',
        headers: {
            'X-Device-ID': currentClientUUID()
        },
        data,
        transformCode: true
    }).then(res => {
        return res;
    });
}

export function getLitigationCountApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/litigation/query/count`,
        method: 'POST',
        data,
        transformCode: true
    });
}

export function getLitigationCaseCountApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/litigation/case/count`,
        method: 'POST',
        headers: {
            'X-API-Version': '1.0',
        },
        data,
        transformCode: true
    });
}

export function getKeywordSuggestApi(params) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/smart/keyword/suggest`,
        method: 'GET',
        params,
        transformCode: true
    });
}

export function getKeyWordSetting() {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/keyword-setting `,
        method: 'GET',
        transformCode: true
    });
}

// corporateTree
export function getCorporateTreeApi(params = {}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/helper/corporate-tree`,
        method: 'GET',
        params,
        transformCode: true
    }).then(({ data }) => {
        return data || {};
    });
}

// corporateTree
export function getPatsnapTreeApi(params = {}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/helper/patsnap-tree`,
        method: 'GET',
        params,
        transformCode: true
    }).then(({ data }) => {
        return data || {};
    });
}

// searchTemplate
// 创建搜索模板
export function createSearchTemplateApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/template`,
        method: 'POST',
        data,
        transformCode: true
    });
}

// 删除搜索模板
export function deleteSearchTemplateApi(templateId) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/template/${templateId}`,
        method: 'DELETE',
        transformCode: true
    });
}

// 修改搜索模板
export function updateSearchTemplateApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/template`,
        method: 'PUT',
        data,
        transformCode: true
    });
}

// 查询搜索模板列表
export function getSearchTemplateListApi() {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/template`,
        method: 'GET',
        transformCode: true
    });
}

export function searchParseQueryApi({ query }) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/parse-query`,
        method: 'POST',
        data: {
            query
        },
        transformCode: true
    }).then(({ data }) => {
        return data.data || {};
    });
}
export function searchSubmitApi({ q, efq, sort, ignore_track, setting }) {
    let params = {
        q,
        efq,
        sort,
        ignore_track
    };
    if (setting) {
        params.setting = setting;
    }
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/submit`,
        method: 'POST',
        data: {
            ...params
        },
        transformCode: true
    }).then(({ data }) => {
        let res = data.data || {};
        let linkParams = _.get(res, 'link_params', {});
        delete linkParams.stem;
        let str = qs.stringify(linkParams);
        res.redirectQuery = str;
        return res;
    });
}

export function searchTransferQueryApi({ query, search_from }, httpConfig = {}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/transfer-query`,
        method: 'POST',
        data: {
            query,
            search_from,
        },
        transformCode: true,
        ...httpConfig
    }).then(({ data }) => {
        let res = data.data || {};
        delete res.stem;
        /**
         * 如果efq里面包含语义搜索SF_FACET命令，那么需要将排序置为最相关排序。
         */
        if (includeSemanticSorting(res.efq)) {
            res.sort = SEMANTIC_RESULT_SORT;
        }
        let url = `/search/result?${qs.stringify(res)}`;
        let redirectUrl = '';
        switch (search_from) {
            case 'field_search':
                redirectUrl = '/search/input/field';
                break;
            case 'simple_search':
                redirectUrl = '/search/input/simple';
                break;
            case 'command_search':
                redirectUrl = '/search/input/command';
                break;
            case 'legal_search':
                redirectUrl = '/search/input/legal';
                break;
            case 'semantic_search':
                redirectUrl = '/search/input/semantic';
                break;
            case 'image_search':
                redirectUrl = '/search/input/image';
                break;
            case 'old-field_search':
                redirectUrl = '/search/input/old-field';
                break;
            case 'project_search':
                redirectUrl = '/search/input/project';
                break;
            case 'classification_search':
                redirectUrl = '/search/input/classification';
                break;
            case 'expand_search':
                redirectUrl = '/search/input/expand';
                break;
            default:
                break;
        }
        if (redirectUrl) {
            url += `&redirect=${encodeURIComponent(redirectUrl)}`;
        }
        res.redirectUrl = url;
        return res;
    });
}

export function searchTransferLitigationQueryApi(queryData, httpConfig = {}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/litigation/transfer-query`,
        method: 'POST',
        data: {
            ...queryData
        },
        transformCode: true,
        ...httpConfig
    }).then(({
        data
    }) => {
        let res = data.data || {};
        delete res.stem;
        res.lc = queryData.lc;
        let url = `/case/result?${qs.stringify(res)}`;
        res.redirectUrl = url;
        return res;
    });
}

export function searchTransferLitigationCaseQueryApi(queryData, httpConfig = {}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/litigation/case/transfer-query`,
        method: 'POST',
        data: {
            ...queryData
        },
        headers: {
            'X-API-Version': '1.0',
        },
        transformCode: true,
        ...httpConfig
    }).then(({
        data
    }) => {
        let res = data.data || {};
        delete res.stem;
        let url = `/legal-case/result?${qs.stringify(res)}`;
        res.redirectUrl = url;
        return res;
    });
}

export function saveSettingApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/search-setting`,
        method: 'PUT',
        data: data,
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
}

export function saveSuggestSettingApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/keyword-setting`,
        method: 'PUT',
        data: data,
        transformCode: true
    }).then(({ data }) => {
        return data.data;
    });
}


export function searchAssignApi(keyword) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/assignee`,
        method: 'GET',
        params: {
            keyword
        },
        transformCode: true
    });
}

export function searchGnameApi(keyword) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/gname`,
        method: 'GET',
        params: {
            keyword
        },
        transformCode: true
    });
}

export function semanticJumpApi({ fromAPD: from_apd, toAPD: to_apd, fromPBD: from_pbd, toPBD: to_pbd, query }) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/input/search/semantic/jump`,
        method: 'POST',
        data: {
            from_apd,
            to_apd,
            from_pbd,
            to_pbd,
            query
        },
        transformCode: true,
        headers: { 'X-API-Version': '2.0' }
    });
}

export function getPatentNumberApi(pn) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/apd`,
        method: 'GET',
        params: {
            pn
        },
        transformCode: true
    });
}

export const getSemanticKeywordApi = ({
    fromAPD: from_apd,
    toAPD: to_apd,
    fromPBD: from_pbd,
    toPBD: to_pbd,
    from_priority_date,
    to_priority_date,
    simple_legal_status,
    ipc,
    query
}) => {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/semantic/keyword`,
        method: 'POST',
        data: {
            from_apd,
            to_apd,
            from_pbd,
            to_pbd,
            from_priority_date,
            to_priority_date,
            simple_legal_status,
            ipc,
            query
        },
        transformCode: true
    }).then(res => res.data || {});
};


export function semanticSearchApi({
    fromAPD: from_apd,
    toAPD: to_apd,
    fromPBD: from_pbd,
    toPBD: to_pbd,
    from_priority_date,
    to_priority_date,
    simple_legal_status,
    ipc,
    ipc_logic_type,
    query,
    immediately,

    //自定义搜索
    query_map,
    filter_query,
    request_id,

    //忽略背景技术
    ignore_background,
    //是否是交底书Playbook查询
    disclosure_playbook
}, tokenConfig) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/input/search/semantic`,
        method: 'POST',
        data: {
            from_apd,
            to_apd,
            from_pbd,
            to_pbd,
            from_priority_date,
            to_priority_date,
            simple_legal_status,
            ipc,
            ipc_logic_type,
            query,
            immediately,
            query_map,
            filter_query,
            request_id,
            ignore_background,
            disclosure_playbook
        },
        transformCode: true,
        ...tokenConfig
    });
}


const apis = {
    history: `${coreSearchApiUrlPrefix}/image/history`,
    uploadImg: `${coreSearchApiUrlPrefix}/image/upload-img`,
    upload: `${coreSearchApiUrlPrefix}/image/upload`,
    uploadMultiImage: `${coreSearchApiUrlPrefix}/image/upload-img`,
    deleteImage: `${coreSearchApiUrlPrefix}/image/delete-image`,
    modifySingleImage: `${coreSearchApiUrlPrefix}/image/upload-single-img`,

    getPatents: `${coreSearchApiUrlPrefix}/image/get-patents`,
    leftFilterInit: `${coreSearchApiUrlPrefix}/image/init`,
    parseQuery: `${coreSearchApiUrlPrefix}/image/parse-query`,
    ranking: `${coreSearchApiUrlPrefix}/image/ranking`
};

const baseHttpConfig = {
    transformCode: true
};

//获取历史记录列表
export function getImgHistoryListApi() {
    return psHttp({
        ...baseHttpConfig,
        url: apis.history,
        method: 'GET'
    });
}

//清除历史记录列表
export function clearImgHistoryApi() {
    return psHttp({
        ...baseHttpConfig,
        url: apis.history,
        method: 'DELETE'
    });
}


//上传图片: form-data
// 老接口
export function uploadImgWithFormDataApi(formData, expandConfig = {}) {
    return psHttp({
        ...baseHttpConfig,
        url: apis.uploadImg,
        method: 'POST',
        data: formData,
        headers: {
            'content-type': 'multipart/form-data'
        },
        ...expandConfig
    });
}

// 多图上传 form-data
export function uploadMultiImageApi(formData, expandConfig = {}) {
    return psHttp({
        ...baseHttpConfig,
        url: apis.uploadMultiImage,
        method: 'POST',
        data: formData,
        headers: {
            'content-type': 'multipart/form-data'
        },
        ...expandConfig
    });
}

// 多图上传 image url
export function uploadMultiImageWithUrlApi({
    patent_type,
    shape_based_first,
    im_search_type,
    images
}, expandConfig = {}) {
    return psHttp({
        ...baseHttpConfig,
        url: apis.uploadMultiImage,
        method: 'POST',
        data: {
            patent_type,
            shape_based_first,
            im_search_type,
            images
        },
        ...expandConfig
    }).then(({ data }) => {
        return data.data;
    });
}

// 删除图片
export function deleteImageApi({
    vector_key,
    image_key
}) {
    return psHttp({
        ...baseHttpConfig,
        url: apis.deleteImage,
        method: 'DELETE',
        data: {
            vector_key,
            image_key
        }
    }).then(({ data }) => {
        return data.data;
    });
}

// 上传裁剪、旋转的图片
export function modifySingleImageApi(formData, expandConfig = {}) {
    return psHttp({
        ...baseHttpConfig,
        url: apis.modifySingleImage,
        method: 'POST',
        data: formData,
        headers: {
            'content-type': 'multipart/form-data'
        },
        ...expandConfig
    }).then(({ data }) => {
        return data.data;
    });
}

// 抠图计算vector，单图上传
export function modifySingleImageCoordinatesApi({
    image_url,
    thumb_url,
    patent_type,
    shape_based_first,
    vector_key,
    image_key,
    coordinates,
    im_search_type
}, expandConfig = {}) {
    return psHttp({
        ...baseHttpConfig,
        url: apis.modifySingleImage,
        method: 'POST',
        data: {
            image_url,
            thumb_url,
            patent_type,
            shape_based_first,
            vector_key,
            image_key,
            coordinates,
            im_search_type,
        },
        ...expandConfig
    }).then(({ data }) => {
        return data.data;
    });
}


/**
 * 上传图片保存历史记录 (搜索并返回linkParams, 前端拼接后跳转)
 * 数据适配
 */
export function uploadImgApi(data) {
    return psHttp({
        ...baseHttpConfig,
        url: apis.upload,
        data,
        method: 'POST'
    });
}


//结果页:获取列表
const fetchPatentChannel = new RequestChannel(psHttp$);
export function getImagePatentsApi(params) {
    return fetchPatentChannel.requestAsPromise({
        // ...baseHttpConfig,
        url: apis.getPatents,
        method: 'POST',
        data: params
    });
}

//结果页: 关键词搜索，左侧过滤提交
const fetchChannelParseQuery = new RequestChannel(psHttp$);
export function parseQueryApi(data) {
    return fetchChannelParseQuery.requestAsPromise({
        // ...baseHttpConfig,
        url: apis.parseQuery,
        method: 'POST',
        data
    });
}


//添加历史记录
export function addImageHistoryApi(params) {
    return psHttp({
        // ...baseHttpConfig,
        url: apis.history,
        method: 'POST',
        data: {
            patent_id: params.patentId,
            img_id: params.imgId,
            patent_type: params.patent_type
        }
    });
}


// 图像结果页 左侧过滤init
export function imageLeftFilterInitApi(data) {
    return psHttp({
        uuid: `filter_init_${JSON.stringify(data)}`,
        url: `${coreSearchApiUrlPrefix}/image/init`,
        method: 'POST',
        data
    });
}


//左侧过滤: ranking
export function getImageLeftFilterRankingApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/image/ranking`,
        method: 'POST',
        data
    });
}

export function transferBioApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/life-sciences`,
        method: 'POST',
        data,
        transformCode: true
    });
}

export function transferChemicalApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/chemical-structures`,
        method: 'POST',
        data,
        transformCode: true
    });
}


//设置init(多模块)
export const settingInitApi = function (type) {
    return psHttp({
        cache: false,
        method: 'GET',
        url: `${coreSearchApiUrlPrefix}/search-setting`,
        params: {
            type
        }
    });
};


/**
 * us code
 * 检测当前用户是否需要弹窗让用户授权系统更新其保存的us数据
 * 当前用户授权系统更新其保存的us数据
 */
export const checkStatusOfUSApi = () => {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/reset_data/check`,
        method: 'GET',
        transformCode: true
    });
};
export const updateStatusOfUSApi = status => {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/reset_data?status=${status}`, // status:1 授权，  status:0  不授权
        method: 'GET',
        transformCode: true
    });
};

export const exportProjectQueryListApi = (project_id, data) => {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/command-project/export/${project_id}`,
        method: 'POST',
        transformCode: true,
        data
    });
};

export const getExportStatusApi = (project_id) => {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/command-project/check-status/${project_id}`,
        method: 'GET',
        transformCode: true,
    });
};

export const exportProjectInit = (project_id) => {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/export/command-search/project-id/${project_id}/init`,
        method: 'GET',
        transformCode: true,
    });
};

// 导出project
export function exportProjectSubmit(data) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/export/command-search/submit`,
        method: 'POST',
        data,
        transformCode: true
    });
}

export function exportProjectPreviewViewInit({
    project_id,
    space_id,
    folder_id
}) {
    return psHttp({
        url: `${coreBasicApiUrlPrefix}/analytics/export/command-search/project-view/init`,
        method: 'POST',
        data: {
            project_id: _.isArray(project_id) ? project_id.join(',') : project_id,
            space_id,
            folder_id
        },
        transformCode: true
    }).then((data) => {
        return data.data || {};
    });
}

export const getCompareListApi = ({ compare_id, page = 1, rows = 20 } = {}) => {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/view/compare/compare-list/${compare_id}`,
        method: 'GET',
        params: { page, rows },
        transformCode: true,
    });
};

export function searchComparePatentApi(data) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/view/compare/compare-search`,
        method: 'POST',
        data,
        transformCode: true
    });
}

const getCorporateCompanyChannel = new RequestChannel(psHttp$);

export const getCorporateCompanyName = ({ q, searchMode, n = 5 }) => {
    return getCorporateCompanyChannel.requestAsPromise({
        url: `${coreSearchApiUrlPrefix}/helper/corporate-tree/company-name`,
        method: 'POST',
        data: {
            q,
            n,
            search_mode: searchMode,
        },
        transformCode: true
    });
};

export const setImageSearchTrack = (data) => {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/image/trace`,
        method: 'POST',
        data
    });
};

//分类号init
export const classificationInitApi = function () {
    return psHttp({
        transformCode: true,
        method: 'GET',
        url: `${coreSearchApiUrlPrefix}/classification/links`,
    });
};

// 左侧过滤init
export const leftFilterInitApi = (data = {}) => {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/filter/srp-init`,
        method: 'POST',
        data
    });
};

// 左侧过滤ranking
export const getleftFilterRankingApi = (data = {}) => {
    let _data = {
        url: `${coreSearchApiUrlPrefix}/filter/ranking`,
        method: 'POST',
        data
    };
    return psHttp(_data);
};

export const getPatentAwardApi = () => {
    let _data = {
        url: `${coreSearchApiUrlPrefix}/patent-award`,
        method: 'GET',
    };
    return psHttp(_data);
};

export const getEPCountriesApi = () => {
    let _data = {
        url: `${coreBasicApiUrlPrefix}/analytics/config/designated-state`,
        method: 'GET',
    };
    return psHttp(_data);
};
